import React from 'react'
import { Alerts, ButtonLoading, HeaderPage, InputText, SelectInput } from '../../Simple'
import { Grid, Box, Typography, Link } from '@mui/material'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { AuthContext } from '../../../contexts/AuthContext'
import BasketLoading from '../../Simple/BasketLoading/BasketLoading'
import LocalStorage from '../../../services/LocalStorage'
import RouterHook from '../../../contexts/RouterHook'
import { Services } from '../../../services'
import CryptoJS from 'crypto-js'
import { returnMaxLength } from '../../../utils/formatPhone'

export default function UserInfo({ desk = false }) {
  const serverRouter = RouterHook()
  const { loadsAuth, actionsAuth, userInfo } = React.useContext(AuthContext)
  const { actionsUCtx } = React.useContext(UsuarioContext)

  async function actionCadastroConfirme() {
    //console.log('userInfo', userInfo)
    actionsAuth.handleLoading('cadastro')
    const req = await actionsAuth.Cadastrar()
    if (req.retorno === true && req.usuario && req.type === 0) {
      //console.log('req.tokens', req)
      actionsUCtx.handleUsuario(req.usuario)
      const bytes = CryptoJS.AES.decrypt(req.tokens.accessToken, import.meta.env.VITE_CRYPTO_KEY)
      LocalStorage.set('user-token', bytes.toString(CryptoJS.enc.Utf8))

      const bytesRefresh = CryptoJS.AES.decrypt(
        req.tokens.refreshToken,
        import.meta.env.VITE_CRYPTO_KEY,
      )
      LocalStorage.set('user-refreshToken', bytesRefresh.toString(CryptoJS.enc.Utf8))

      let query = ''
      let usuario = req.usuario
      if (usuario.cidade && usuario.estado) {
        query = `${usuario.estado?.length === 2 ? usuario.estado : Services.ReturnSiglaEstado(usuario.estado)}-${Services.RemoveCaracteresEspeciais(
          usuario.cidade,
        )}`
      } else {
        query = ':localizacao'
      }
      const url = LocalStorage.get('url-selecionada')
      actionsAuth.clearUiControls()
      if (url) {
        // url esta https://site.agendeiquadras.com.br/centro-esportivo/query pegar ultima parte depois do /
        query = url.url.split('/').pop()
        LocalStorage.remove('url-selecionada')
        LocalStorage.set('back-action', true)
        serverRouter('centro-esportivo', query)
      } else {
        //console.log('query', query)
        serverRouter('home', query.toLowerCase())
      }
    }
    actionsAuth.handleLoading('off')
  }

  function ValidarDados() {
    const nomeValido = userInfo.name.split(' ').filter(n => n.length > 1).length >= 2
    const telefone = userInfo.phone.replace(/\D/g, '')
    const telefoneValido = telefone.length === returnMaxLength(userInfo.pais)
    const dataNascimentoValida = /^\d{2}\/\d{2}\/\d{4}$/.test(userInfo.nasc)

    return !(nomeValido && telefoneValido && dataNascimentoValida)
  }

  return (
    <>
      {loadsAuth === 'cadastro' && !desk && <BasketLoading />}
      <Box sx={{ height: '100%' }}>
        {!desk && (
          <HeaderPage
            title='Quase pronto...'
            subTitle='Insira seus dados pessoais'
            action={() => {
              actionsAuth.authStep('login')
            }}
          />
        )}
        <Grid container spacing={2} sx={{ px: 2 }}>
          <Grid item xs={12}>
            <InputText
              type='text'
              label='Nome Completo*'
              value={userInfo.name}
              onKeyDown={e => {
                if (e.key === 'Enter' && desk) {
                  e.preventDefault()
                  actionCadastroConfirme()
                }
              }}
              onChange={e => {
                actionsAuth.handleInputChange('name', e)
              }}
            />
          </Grid>

          <Grid item xs={4}>
            <SelectInput
              label='País'
              value={userInfo.pais}
              onChange={e => {
                actionsAuth.handleInputChange('pais', e)
              }}
              options={[
                { value: '+55', label: '🇧🇷 (+55)' },
                { value: '+54', label: '🇦🇷 (+54)' },
                { value: '+598', label: '🇺🇾 (+598)' },
                { value: '+595', label: '🇵🇾 (+595)' },
                { value: '+591', label: '🇧🇴 (+591)' },
                { value: '+51', label: '🇵🇪 (+51)' },
                { value: '+57', label: '🇨🇴 (+57)' },
                { value: '+58', label: '🇻🇪 (+58)' },
              ]}
            />
          </Grid>
          <Grid item xs={8}>
            <InputText
              type='tel'
              label='Telefone*'
              value={userInfo.phone}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  actionCadastroConfirme()
                }
              }}
              onChange={e => {
                actionsAuth.handleChangePhone(e)
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <SelectInput
              label='Gênero'
              value={userInfo.genero}
              onChange={e => actionsAuth.handleInputChange('genero', e)}
              options={[
                { value: '', label: 'Não informar' },
                { value: 'Masculino', label: 'Masculino' },
                { value: 'Feminino', label: 'Feminino' },
                { value: 'Outro', label: 'Outro' },
              ]}
            />
          </Grid>
          <Grid item xs={6}>
            <InputText
              type='tel'
              value={userInfo.nasc}
              label='Data de Nascimento*'
              placeholder='DD/MM/YYYY'
              onChange={e => {
                const vs = Services.DataFormat('input-nascimento', e.target.value)
                // Verifica se a data é antes de 2013
                if (vs.length < 10) {
                  actionsAuth.handleDateChange(vs)
                } else if (
                  vs.length === 10 &&
                  Services.DataFormat('input-nascimento', e.target.value).split('/')[2] < 2009
                ) {
                  actionsAuth.handleDateChange(vs)
                } else {
                  Alerts.swal(
                    'warning',
                    'Data de nascimento inválida',
                    'A idade mínima para cadastro é de 12 anos',
                  )
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            <ButtonLoading
              disabled={ValidarDados()}
              onClick={actionCadastroConfirme}
              loading={loadsAuth === 'cadastro'}
              fullWidth={!desk}
              sx={desk ? { width: '250px' } : {}}
            >
              Continuar
            </ButtonLoading>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='body2' className='tw-text-center'>
              Ao criar uma conta, você concorda com todos os
              <br />
              <Link
                href='https://agendeiquadras.com.br/termos.html'
                underline='none'
                target='_blank'
              >
                termos e políticas
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
